import { render, staticRenderFns } from "./KeyColumnModal.vue?vue&type=template&id=e1940f20&scoped=true&"
import script from "./KeyColumnModal.vue?vue&type=script&lang=js&"
export * from "./KeyColumnModal.vue?vue&type=script&lang=js&"
import style0 from "./KeyColumnModal.vue?vue&type=style&index=0&id=e1940f20&lang=scss&scoped=true&"
import style1 from "./KeyColumnModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1940f20",
  null
  
)

export default component.exports